import { ORG_TYPE_GUIDANCE, orgTypeDescription } from "@/lib/orgTypeOptions";

/**
 * Helper text under an organization type picker: the selected type's meaning,
 * then the rule for which unit gets a profile.
 */
export function OrgTypeHelp({ value, id }: { value: unknown; id?: string }) {
  const description = orgTypeDescription(value);
  return (
    <div id={id} className="space-y-1 text-xs text-muted-foreground" data-org-type-help>
      {description && <p className="m-0 text-foreground/80">{description}</p>}
      <p className="m-0">{ORG_TYPE_GUIDANCE}</p>
    </div>
  );
}
